import { AdminAuditLogConfig } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/admin-audit-log-config/model';
import { updateExoOrganizationConfig } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/organization-config/actions';

export function Remediate(_tenant: string, data: Partial<AdminAuditLogConfig>, schema: any) {
    if (schema.properties.CustomerLockboxEnabled.const === false) {
        return updateExoOrganizationConfig({ _tenant, data: { CustomerLockboxEnabled: false } });
    }

    if (schema.properties.CustomerLockboxEnabled.const === true) {
        return updateExoOrganizationConfig({ _tenant, data: { CustomerLockboxEnabled: true } });
    }
}
